import { render, staticRenderFns } from "./TemplatePublishModal.vue?vue&type=template&id=10022903&"
import script from "./TemplatePublishModal.vue?vue&type=script&lang=js&"
export * from "./TemplatePublishModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePublishModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports